module.exports = __webpack_public_path__ + "static/Fran-Colwell-Donation-Greg-Dyment-Michael-Karg-800x600-1-800x500-ac030709ec143b79a5d7521c92df3a30.jpg";